var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"mx-auto pa-8"},[_c('v-card-text',{staticClass:"d-flex justify-center"},[_c('h1',[_vm._v("Successfully submitted publication!")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }